import { Injectable } from '@angular/core';
import { DeliveryDatesRequest, ErrorType } from '@dgx-pr-spa/shared/util';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import * as fromProductDetails from '../store/actions';
import * as fromProductDetailsState from '../store/reducers';
import * as fromProductDetailsQuery from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class ProductDetailsService {
  constructor(
    public readonly store?: Store<fromProductDetailsState.ProductDetailsState>
  ) {}

  readonly deliveryDatesState$ = this.store.select(
    fromProductDetailsQuery.getDeliveryDatesState
  );

  readonly deliveryDates$ = this.store.select(
    fromProductDetailsQuery.getDeliveryDates
  );

  readonly deliveryDatesLoading$ = this.store.select(
    fromProductDetailsQuery.getDeliveryDatesLoading
  );

  readonly deliveryDatesLoaded$ = this.store.select(
    fromProductDetailsQuery.getDeliveryDatesLoaded
  );

  readonly deliveryDatesError$ = this.store.select(
    fromProductDetailsQuery.getDeliveryDatesError
  );

  readonly deliveryApiError$ = this.deliveryDatesState$.pipe(
    map(({ error }) => this.isDeliveryApiError(error))
  );

  readonly DeliveryErrorType = ErrorType;

  readonly selected$ = this.store.select(
    fromProductDetailsQuery.getSelectedOffer
  );

  readonly getDeliveryDatesRequestArgs$ = this.store.select(
    fromProductDetailsQuery.getDeliveryDatesRequestArgs
  );

  loadDeliveryDates(payload?: DeliveryDatesRequest) {
    this.store.dispatch(fromProductDetails.loadDeliveryDates({ payload }));
  }

  loadDeliveryDatesFail(payload) {
    this.store.dispatch(fromProductDetails.loadDeliveryDatesFail({ payload }));
  }

  handleDeliveryApiError(payload) {
    this.store.dispatch(fromProductDetails.handleDeliveryApiError({ payload }));
  }

  triggerDeliveryApiError(payload) {
    this.store.dispatch(
      fromProductDetails.triggerDeliveryApiError({ payload })
    );
  }

  resetDeliveryDates() {
    this.store.dispatch(fromProductDetails.resetDeliveryDates());
  }

  isDeliveryApiError(error) {
    return error?.includes(
      this.DeliveryErrorType.DELIVERY_API_ERROR.toString()
    );
  }
}
